import { Injectable } from '@angular/core';
import { VideoLayerDetailsApiService } from './video-layer-details-api.service';
import {
    IRemoveVideoLayerRequest,
    IUpdateVideoLayerDryDetailsRequestBody,
    IVideoLayerFinishRecordingRequest,
} from '../../../../../http-models/project/video-layer/video-layer-http-request-model';
import { handleApiCallAsync } from '../../../../../../utils/general-functions';

@Injectable()
export class VideoLayerDetailsApiManagerService {
    constructor(private videoLayerApiService: VideoLayerDetailsApiService) {}

    public async finishRecordingAsync(request: IVideoLayerFinishRecordingRequest) {
        const { data, error } = await handleApiCallAsync(this.videoLayerApiService.finishRecording$(request));
        if (error || !data) {
            console.error(`AN error occurred while finishing take`, error);
            throw error;
        }
        return data;
    }

    public async updateDryDetailsAsync(request: IUpdateVideoLayerDryDetailsRequestBody) {
        return handleApiCallAsync(this.videoLayerApiService.updateDryDetails$(request));
    }

    public async removeVideoLayerAsync(request: IRemoveVideoLayerRequest) {
        return await handleApiCallAsync(this.videoLayerApiService.removeVideoLayer$(request));
    }
}
